import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { format, eachDayOfInterval, startOfMonth, endOfMonth } from 'date-fns';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const API_KEY = "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079";
const API_BASE_URL = "https://api.muktihospital.com/api";

const PathologyPerformanceChart = () => {
    const [chartData, setChartData] = useState({ series: [], options: {} });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchChartData = async () => {
            setLoading(true);
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const monthPadded = String(month).padStart(2, '0');

            const firstDay = startOfMonth(now);
            const lastDay = endOfMonth(now);
            const daysOfMonth = eachDayOfInterval({ start: firstDay, end: lastDay });

            const labels = daysOfMonth.map(day => format(day, 'd'));
            const dailyTestsBilled = Array(daysOfMonth.length).fill(0);
            const dailyPatients = Array(daysOfMonth.length).fill(0);

            try {
                const api = axios.create({ baseURL: API_BASE_URL, headers: { "x-api-key": API_KEY } });

                const response = await api.get(`/pathology-bill/bills/monthly?year=${year}&month=${monthPadded}`);
                const monthlyBills = response.data?.data?.bills || response.data?.bills || [];
                
                daysOfMonth.forEach((day, index) => {
                    const dateStr = format(day, 'yyyy-MM-dd');
                    const billsForDay = monthlyBills.filter(bill => {
                        const billDate = bill.billingDate || bill.createdAt;
                        return billDate && billDate.startsWith(dateStr);
                    });
                    
                    dailyTestsBilled[index] = billsForDay.reduce((sum, bill) => sum + (bill.serviceItems?.length || 1), 0);

                    const uniquePatients = new Set(billsForDay.map(bill => bill.patientName));
                    dailyPatients[index] = uniquePatients.size;
                });
                
                setChartData({
                    series: [
                        { name: 'Tests Billed', type: 'column', data: dailyTestsBilled },
                        { name: 'Patients Served', type: 'line', data: dailyPatients }
                    ],
                    options: {
                        chart: { height: 400, type: 'line', toolbar: { show: false } },
                        stroke: { width: [0, 4], curve: 'smooth' },
                        plotOptions: { bar: { borderRadius: 4, columnWidth: '60%' } },
                        dataLabels: { enabled: false },
                        labels: labels,
                        yaxis: { labels: { formatter: (val) => `${Math.round(val)}` } },
                        colors: ["#6AC75A", "#465DFF"],
                        tooltip: { 
                            y: { 
                                formatter: (val) => `৳${Math.round(val).toLocaleString()}` 
                            } 
                        }
                    },
                });

            } catch (error) {
                console.error("Error fetching chart data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchChartData();
    }, []);

    if (loading) {
        return <Skeleton height={400} />;
    }

    return (
        <div>
            <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="line"
                height={400}
            />
        </div>
    );
};

export default PathologyPerformanceChart;